// extracted by mini-css-extract-plugin
module.exports = {"container":"_5aKNbw","title":"_1zvIy4","time-container":"zFujAs","time-value":"_1KPNbQ","time-label":"_2V8HlM","time-second":"pprZ1H"};